module.exports = __webpack_public_path__ + "static/media/marks.6bc3606c.svg";